<template>
  <ul class="card-price">
    <li
      v-for="(field, index) in fields"
      :key="`card-price-field-${index}`"
      class="card-price__field"
    >
      <span class="card-price__label">{{ field.label }}</span>
      {{ field.data }}
    </li>
    <HdButton @click="navigateToValuationWizard()">
      {{ $t('DASHBOARD.CARD.EXPANDED.PRICE.CTA_LABEL') }}
    </HdButton>
  </ul>
</template>

<script>
import { HdButton } from 'homeday-blocks';
import { SLIDES as SLIDES_ROUTE_NAMES } from '@/router/wizard/ROUTE_NAMES';

export default {
  name: 'PriceDetailsCard',
  components: { HdButton },
  props: {
    deal: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fields() {
      return [
        {
          label: this.$t('DASHBOARD.CARD.EXPANDED.PRICE.MARKETING_PRICE'),
          data:
            this.deal?.property?.details?.marketing_price > 0
              ? this.$formatPrice(this.deal.property.details.marketing_price)
              : null,
        },
        {
          label: this.$t('DASHBOARD.CARD.EXPANDED.PRICE.SELLING_PRICE'),
          data:
            this.deal?.property?.details?.price > 0
              ? this.$formatPrice(this.deal.property.details.price)
              : null,
        },
        {
          label: this.$t('DASHBOARD.CARD.EXPANDED.PRICE.SELLER_COMMISION'),
          data: this.deal?.property?.details?.seller_commission_percent_gross
            ? `${this.$formatNumber(this.deal.property.details.seller_commission_percent_gross, {
                fractionDigits: 2,
              })}%`
            : null,
        },
        {
          label: this.$t('DASHBOARD.CARD.EXPANDED.PRICE.BUYER_COMMISION'),
          data: this.deal?.property?.details?.buyer_commission_percent_gross
            ? `${this.$formatNumber(this.deal?.property?.details?.buyer_commission_percent_gross, {
                fractionDigits: 2,
              })}%`
            : null,
        },
      ].filter((field) => field.data);
    },
  },
  methods: {
    navigateToValuationWizard() {
      const dealUid = this.deal?.uid;
      this.$router.push({ name: SLIDES_ROUTE_NAMES.INDEX, params: { dealUid } });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.card-price {
  &__field {
    @include font('DS-90');
    display: flex;
    gap: $sp-s - $sp-xxs;

    &:not(:last-child) {
      margin-bottom: $sp-s;

      @include for('tablet') {
        margin-bottom: $sp-m;
      }
    }

    @include for('tablet') {
      @include font('DS-100');
    }
  }

  &__label {
    font-weight: 700;
  }

  button {
    margin-top: $sp-s;
    width: 100%;

    @include for('tablet') {
      margin-top: 0;
    }
  }
}
</style>
